import { useState,useEffect } from "react"
import { useProject } from "../Providers"

import style from "./controlPanel.module.scss"
import MenuScreen from "./MenuScreen"

const ControlPanelTexts = () => {
	const { user, setting, setSetting } = useProject()
	const [state, setstate] = useState({
		bus: false,
		stoppath: false,
		stop: false,
		image: true,
		sounds: false,
		texts:false,
		version:false,
		userTemplates: false,
	})

	const handleChange = (e) =>{
		setstate((prev) => {
			for (const key in prev) prev[key] = false
			return {
				...prev,
				[e.target.name]: !(e.target.value === "true" && true),
			}
		})

		setSetting({
			...setting,
			leftbar : e.target.name
		})
	}

	return (
		<div className={style.controlPanelOptions}>
			{user && (
				<>
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='image'
							value={state.image}
							onClick={handleChange}
						>
							Image
						</button>
						{state.image && 
							<MenuScreen setting={setting} setSetting={setSetting}/>
						}
					</div>				
					
				</>
			)}
		</div>
	)
}

export default ControlPanelTexts
